<template>
  <div style="background-color: #000000; min-height: 100vh;">
    <div data-v-ab7e7df3="" data-v-1ed58d81="" class="app-download-bar-v2" v-if="appshow">
      <div data-v-ab7e7df3="" class="flex-center">
        <span data-v-ab7e7df3="" class="close-btn" @click="appshow = false">×</span>
        <div data-v-ab7e7df3="" class="icon">
          <img data-v-ab7e7df3="" src="https://9pgh5.liwifi.top/assets/9pg-DYmuSJSM.png" alt="icon" class="fit-image">
        </div>
        <div data-v-ab7e7df3="" class="medium-text text">{{ $t('Official Domain') }}<span data-v-ab7e7df3="" class="text-domain-name">9PG.app</span>{{ $t('Please Install APP') }}</div>
      </div>
      <div data-v-ab7e7df3="" class="download-btn" @click="$parent.goNav('/app')">{{ $t('Download Now') }}&gt;</div>
    </div>
    
    <div style="position: relative"></div>

    <div class="domainModal_domainView__FWCzg" v-if="goInfo">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="goInfo = null"></div>
      <div class="domainModal_content__1nBgc" style="width: 80%">
        <img src="/static/image/hongbaocolse.png" @click="goInfo = null" style="position: absolute; top: 5px; right: 13px; width: 0.7rem" alt="" />
        <div class="domainModal_middle__3gQPm" style="padding: 35px 10px 15px">
          {{ goInfo }}
          <van-button type="info" style="margin: 0 auto; margin-top: 20px; width: 120px; border-radius: 10px; height: 35px" @click="$parent.goNav('/message')">{{ $t('More Announcements') }}</van-button>
        </div>
      </div>
    </div>

    <div class="xiding" :style="{ top: appshow ? '1rem' : '0' }">
      
      <div class="logo-wrapper">
        <img :src="$store.state.appInfo.site_logo || '/static/brand/zx-logo.png'" alt="众鑫" class="logo-icon lu-logo">
        
      </div>

      <div class="banner-wrapper" v-if="bannerList.length > 0">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" @change="onChange">
          <van-swipe-item v-for="(banner, index) in bannerList" :key="index">
            <img :src="banner.src" class="banner-img" @click="openBanner(banner.url)" />
          </van-swipe-item>
          <template #indicator>
            <div class="swiper-dots">
              <div class="num">{{ current + 1 }}</div>
              <div class="sign">/</div>
              <div class="num">{{ bannerList.length }}</div>
            </div>
          </template>
        </van-swipe>
      </div>

      <div class="caosuo">
        <div class="lefsg" v-if="$store.state.token">
          <div class="meys">
            <div class="lefs">
              <span>￥</span>{{ $store.getters.safeBalance }}
              <div class="imsg" @click="refreshBalance">
                <img :class="{ 'rotate': isRefreshing }" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAwUExURUdwTCUlJSgoKCkpKSgoKCkpKSkpKSkpKSoqKigoKCkpKScnJygoKCMjIygoKCoqKseuDdQAAAAPdFJOUwAQf+A/vplf7yDPL28fT1x7ifYAAADwSURBVCjPnVG7DgFRFLzeESKbKAiNKLQahUZWr6BCI0voUWvEDygkCo1S6R/4AJ/isesRIuO+F1GZYueeyZycOWcJ+Y10xXgv/V3A7rl1xAJDSws74FakSkbWXqBhkISFkxTyKDCKmdISwV1MWMDh7ENJOMPmmfMeZdlbFa/+WU0LoM1oelVCCGP69eCphDCOLDYOOiEe34KjfRyye+ropYXZuighiBrf9aZus8SAUVLoLKLNKarW9kJGtNDhM/rKGoc9pPUWYhWaZA3Uc016w5N7Q4aJqa86N1ltzLSF+DfZEe/NfP6/lEjmwrMi/+AFJYxumJPpNugAAAAASUVORK5CYII=" alt="reload" class="fit-image" />
              </div>
            </div>
          </div>
        </div>
        
        <!-- 更新后的登录注册按钮区域 -->
        <div v-else class="balance-wrapper">
          <div class="login-wrapper">
            <div class="regist-button button custom-reg-btn medium" @click="showRegister = true">
              {{ $t('Register') }}
            </div>
            <div id="login-button" class="button custom-login-btn medium" @click="showLogin = true">
              {{ $t('Login') }}
            </div>
          </div>
        </div>
       
        <div class="riggs">
          <div class="lisImg" @click="$parent.goNav('/recharge')">
            <div class="img-wrapper">
              <img src="/static/style/feature_moneydraw.cbeb513bc9fd00ecc5372fc0e54a84c0.png" alt="" />
              <div class="right-top-label">送3%</div>
            </div>
            <div class="icon-text">{{ $t('Deposit') }}</div>
          </div>
          <div class="lisImg" @click="$parent.goNav('/withdrawal')">
            <img src="/static/style/feature_moneysave.4b60fbaf4ee368d1e7060133f62690c9.png" alt="" />
            <div class="icon-text">{{ $t('Withdraw') }}</div>
          </div>
          <div class="lisImg" @click="$parent.openKefu">
            <img src="/static/style/kffff.png" alt="" />
            <div class="icon-text">{{ $t('Customer Service') }}</div>
          </div>
          <div class="lisImg" @click="$parent.goNav('/hongbao')">
            <div class="link-icon rebate-icon pg-rebate-icon">
              <img src="/static/style/icon-profit-rain-dq3TXISv.png" alt="rebate" class="fit-image">
            </div>
            <div class="icon-text" style="color: rgb(250, 29, 29);"> {{ $t('Red Envelope Rain') }} </div>
          </div>
        </div>
      </div>

      <div class="top-tab-bar" v-if="gameType === 2 || gameType === 3 || gameType === 4 || gameType === 5">
        <div class="game-type-tabs">
          <template v-if="gameType === 2">
            <div class="game-type-tab" :class="{ 'active': !selectedFishingPlatform }" @click="selectFishingPlatform('')">{{ $t('All') }}</div>
            <div class="game-type-tab" :class="{ 'active': selectedFishingPlatform === 'BGBY' }" @click="selectFishingPlatform('BGBY')">BG</div>
            <div class="game-type-tab" :class="{ 'active': selectedFishingPlatform === 'AG' }" @click="selectFishingPlatform('AG')">PA</div>
          </template>
          <template v-if="gameType === 3">
            <div class="game-type-tab" :class="{ 'active': !selectedJokerPlatform }" @click="selectJokerPlatform('')">{{ $t('All') }}</div>
            <div class="game-type-tab" :class="{ 'active': selectedJokerPlatform === 'BBQP' }" @click="selectJokerPlatform('BBQP')">BBIN</div>
            <div class="game-type-tab" :class="{ 'active': selectedJokerPlatform === 'BGQP' }" @click="selectJokerPlatform('BGQP')">BG</div>
            <div class="game-type-tab" :class="{ 'active': selectedJokerPlatform === 'AG' }" @click="selectJokerPlatform('AG')">AG</div>
          </template>
          <template v-if="gameType === 4">
            <div class="game-type-tab" :class="{ 'active': selectedPlatform === 'PG' }" @click="selectPlatform('PG')">PG</div>
            <div class="game-type-tab" :class="{ 'active': selectedPlatform === 'PP' }" @click="selectPlatform('PP')">PP</div>
            <div class="game-type-tab" :class="{ 'active': selectedPlatform === 'CQ9' }" @click="selectPlatform('CQ9')">CQ9</div>
            <div class="game-type-tab" :class="{ 'active': selectedPlatform === 'JDB' }" @click="selectPlatform('JDB')">JDB</div>
            <div class="game-type-tab" :class="{ 'active': selectedPlatform === 'JILI' }" @click="selectPlatform('JILI')">JILI</div>
            <div class="game-type-tab" :class="{ 'active': selectedPlatform === 'FC' }" @click="selectPlatform('FC')">FC</div>
            <div class="game-type-tab" :class="{ 'active': selectedPlatform === 'WG' }" @click="selectPlatform('WG')">WG</div>
          </template>
          <template v-if="gameType === 5">
            <div class="game-type-tab" :class="{ 'active': !selectedLotteryPlatform }" @click="selectLotteryPlatform('')">{{ $t('All') }}</div>
            <div class="game-type-tab" :class="{ 'active': selectedLotteryPlatform === 'LHC' }" @click="selectLotteryPlatform('LHC')">{{ $t('Mark Six') }}</div>
            <div class="game-type-tab" :class="{ 'active': selectedLotteryPlatform === 'JSC' }" @click="selectLotteryPlatform('JSC')">{{ $t('Speed Lottery') }}</div>
            <div class="game-type-tab" :class="{ 'active': selectedLotteryPlatform === 'JWC' }" @click="selectLotteryPlatform('JWC')">{{ $t('Overseas Lottery') }}</div>
            <div class="game-type-tab" :class="{ 'active': selectedLotteryPlatform === 'QKC' }" @click="selectLotteryPlatform('QKC')">{{ $t('Blockchain Lottery') }}</div>
          </template>
        </div>
        <div class="search-icon" @click="toggleSearchBox" v-if="gameType === 4">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAwUExURUdwTCUlJSgoKCkpKSgoKCkpKSkpKSkpKSoqKigoKCkpKScnJygoKCMjIygoKCoqKseuDdQAAAAPdFJOUwAQf+A/vplf7yDPL28fT1x7ifYAAADwSURBVCjPnVG7DgFRFLzeESKbKAiNKLQahUZWr6BCI0voUWvEDygkCo1S6R/4AJ/isesRIuO+F1GZYueeyZycOWcJ+Y10xXgv/V3A7rl1xAJDSws74FakSkbWXqBhkISFkxTyKDCKmdISwV1MWMDh7ENJOMPmmfMeZdlbFa/+WU0LoM1oelVCCGP69eCphDCOLDYOOiEe34KjfRyye+ropYXZuighiBrf9aZus8SAUVLoLKLNKarW9kJGtNDhM/rKGoc9pPUWYhWaZA3Uc016w5N7Q4aJqa86N1ltzLSF+DfZEe/NfP6/lEjmwrMi/+AFJYxumJPpNugAAAAASUVORK5CYII=" alt="search" class="search-img">
        </div>
        <div class="search-box" v-if="showSearchBox && gameType === 4">
          <div class="search-input-wrapper">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAwUExURUdwTCUlJSgoKCkpKSgoKCkpKSkpKSkpKSoqKigoKCkpKScnJygoKCMjIygoKCoqKseuDdQAAAAPdFJOUwAQf+A/vplf7yDPL28fT1x7ifYAAADwSURBVCjPnVG7DgFRFLzeESKbKAiNKLQahUZWr6BCI0voUWvEDygkCo1S6R/4AJ/isesRIuO+F1GZYueeyZycOWcJ+Y10xXgv/V3A7rl1xAJDSws74FakSkbWXqBhkISFkxTyKDCKmdISwV1MWMDh7ENJOMPmmfMeZdlbFa/+WU0LoM1oelVCCGP69eCphDCOLDYOOiEe34KjfRyye+ropYXZuighiBrf9aZus8SAUVLoLKLNKarW9kJGtNDhM/rKGoc9pPUWYhWaZA3Uc016w5N7Q4aJqa86N1ltzLSF+DfZEe/NfP6/lEjmwrMi/+AFJYxumJPpNugAAAAASUVORK5CYII=" alt="search" class="search-img-inside">
            <input type="text" v-model="searchKeyword" @input="searchGames" :placeholder="$t('Search Games')" class="search-input-with-icon">
          </div>
          <div class="search-close" @click="closeSearchBox">×</div>
        </div>
      </div>
    </div>

    <div class="gameBoxs" :style="{ marginTop: (6.2 + (appshow ? 1 : 0) + ([2, 3, 4, 5].includes(gameType) ? 1.0 : 0)) + 'rem' }">
      <div class="lfst" :style="{ top: (6.2 + (appshow ? 1 : 0) + ([2, 3, 4, 5].includes(gameType) ? 1.0 : 0)) + 'rem' }">
        <div :class="gameType == -1 ? 'ls active' : 'ls'" @click="changGameType(-1)">
          <img :src="`/static/style/${gameType == -1 ? 'sidebar_lottery_icon_select' : 'sidebar_lottery_icon_nor'}.png`" alt="" />
          <span>新澳门六合彩</span>
        </div>
        <div :class="gameType == 6 ? 'ls active' : 'ls'" @click="changGameType(6)">
          <img :src="`/static/style/${gameType == 6 ? 'sidebar_casino_icon_select' : 'sidebar_casino_icon_nor'}.png`" alt="" />
          <span>{{ $t('Hot') }}</span>
        </div>
        <div :class="gameType == 4 ? 'ls active' : 'ls'" @click="changGameType(4)">
          <img :src="`/static/style/${gameType == 4 ? 'sidebar_slot_icon_select' : 'sidebar_slot_icon_nor'}.png`" alt="" />
          <span>{{ $t('Slots') }}</span>
        </div>
        <div :class="gameType == 0 ? 'ls active' : 'ls'" @click="changGameType(0)">
          <img :src="`/static/style/${gameType == 0 ? 'sidebar_casino_icon_select' : 'sidebar_casino_icon_nor'}.png`" alt="" />
          <span>{{ $t('Live Casino') }}</span>
        </div>
        <div :class="gameType == 1 ? 'ls active' : 'ls'" @click="changGameType(1)">
          <img :src="`/static/style/${gameType == 1 ? 'sidebar_sports_icon_select' : 'sidebar_sports_icon_nor'}.png`" alt="" />
          <span>{{ $t('Sports') }}</span>
        </div>
        <div :class="gameType == 2 ? 'ls active' : 'ls'" @click="changGameType(2)">
          <img :src="`/static/style/${gameType == 2 ? 'sidebar_esports_icon_select' : 'sidebar_esports_icon_nor'}.png`" alt="" />
          <span>{{ $t('Fishing') }}</span>
        </div>
        <div :class="gameType == 3 ? 'ls active' : 'ls'" @click="changGameType(3)">
          <img :src="`/static/style/${gameType == 3 ? 'sidebar_board_icon_select' : 'sidebar_board_icon_nor'}.png`" alt="" />
          <span>{{ $t('Board Games') }}</span>
        </div>
        <div :class="gameType == 5 ? 'ls active' : 'ls'" @click="changGameType(5)">
          <img :src="`/static/style/${gameType == 5 ? 'sidebar_lottery_icon_select' : 'sidebar_lottery_icon_nor'}.png`" alt="" />
          <span>{{ $t('Lottery') }}</span>
        </div>
      </div>

      <div class="content-area">
        <div class="cross-lottery-panel" v-if="gameType == -1">
          <div class="cross-lottery-card" @click="openLottery">
            <div class="cross-lottery-card__head">
              <div><strong>新澳门六合彩</strong><span>总盘大数据反向带货</span></div>
              <em><i></i>开放中</em>
            </div>
            <div class="cross-lottery-card__body">
              <div class="cross-lottery-card__copy">
                <strong>总盘大数据反向带货</strong>
                <span>平台打39码 私庄打10码<br />合作共赢</span>
              </div>
              <div class="cross-lottery-card__art">
                <img src="/static/style/sidebar_lottery_icon_select.png" alt="开奖" />
                <i></i><i></i><i></i>
              </div>
            </div>
            <div class="cross-lottery-card__foot">
              <span>当前账号可免登录进入</span>
              <button type="button">进入开奖 <b>›</b></button>
            </div>
          </div>
        </div>
        <div class="rigts hot-grid" v-if="gameType == 6">
          <div class="game-item" v-for="(item, index) in $store.state.fishingList" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.name || item.game_name || item.title)">
            <div class="game-icon-container">
              <img :src="getGameImg(item, 'fishing')" alt="" />
              <div class="api-icon" v-if="item.api_logo_img">
                <img :src="item.api_logo_img" alt="API Icon" />
              </div>
            </div>
            <div class="game-name">{{ $t(item.name || item.game_name || item.title || 'Game') }}</div>
          </div>
        </div>
        <div class="rigts single-column realbet-content" v-if="gameType == 0">
          <div class="realbet-game-item" v-for="(item, index) in $store.state.realbetList" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.name || item.game_name || item.title)">
            <div class="realbet-icon-container">
              <img :src="getGameImg(item, 'realbet')" alt="" />
            </div>
          </div>
        </div>
        <div class="rigts single-column sport-content" v-if="gameType == 1">
          <div class="sport-game-item" v-for="(item, index) in $store.state.sportList" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.name || item.game_name || item.title)">
            <div class="sport-icon-container">
              <img :src="getGameImg(item, 'sport')" alt="" />
            </div>
          </div>
        </div>
        <div class="rigts three-column" v-if="gameType == 2">
          <div class="game-item" v-for="(item, index) in filteredFishingGames.length > 0 ? filteredFishingGames : $store.state.gamingList" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.name || item.game_name || item.title)">
            <div class="game-icon-container">
              <img :src="getGameImg(item, 'gaming')" alt="" />
              <div class="api-icon" v-if="item.api_logo_img">
                <img :src="item.api_logo_img" alt="API Icon" />
              </div>
            </div>
            <div class="game-name">{{ $t(item.name || item.game_name || item.title || 'Game') }}</div>
          </div>
        </div>
        <div class="rigts three-column" v-if="gameType == 3">
          <div class="game-item" v-for="(item, index) in filteredJokerGames.length > 0 ? filteredJokerGames : $store.state.jokerList" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.name || item.game_name || item.title)">
            <div class="game-icon-container">
              <img :src="getGameImg(item, 'joker')" alt="" />
              <div class="api-icon" v-if="item.api_logo_img">
                <img :src="item.api_logo_img" alt="API Icon" />
              </div>
            </div>
            <div class="game-name">{{ $t(item.name || item.game_name || item.title || 'Game') }}</div>
          </div>
        </div>
        <div class="rigts three-column" v-if="gameType == 4">
          <div class="game-item" v-for="(item, index) in filteredGames.length > 0 ? filteredGames : $store.state.conciseList" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.name || item.game_name || item.title)">
            <div class="game-icon-container">
              <img :src="getGameImg(item, 'concise')" alt="" />
              <div class="api-icon" v-if="item.api_logo_img">
                <img :src="item.api_logo_img" alt="API Icon" />
              </div>
            </div>
            <div class="game-name">{{ $t(item.name || item.game_name || item.title || 'Game') }}</div>
          </div>
        </div>
        <div class="rigts three-column" v-if="gameType == 5">
          <div class="game-item" v-for="(item, index) in filteredLotteryGames" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.name || item.game_name || item.title)" :class="{ 'full-width': item.platform_name == 'vrbet' }">
            <div class="game-icon-container">
              <img :style="item.platform_name == 'vrbet' ? 'width:100%' : ''" :src="getGameImg(item, 'lottery')" alt="" />
              <div class="api-icon" v-if="item.api_logo_img">
                <img :src="item.api_logo_img" alt="API Icon" />
              </div>
            </div>
            <div class="game-name">{{ $t(item.name || item.game_name || item.title || 'Game') }}</div>
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="leftshow" position="left" :style="{ height: '100%' }">
      <div class="leftbox">
        <div class="side__main__1NhyG">
          <h3>{{ $t('Welcome to') }}{{ $store.state.appInfo.title }}</h3>
          <dl class="side__vip__1dW8w">
            <div class="topxs">{{ $t('Exclusive VIP Experience') }}</div>
            <p>{{ $t('Enjoy member privileges') }}</p>
            <p>{{ $t('Enjoy uniqueness that belongs only to you') }}</p>
            <dd @click="$parent.goNav('/vip')">{{ $t('Member Center') }}</dd>
          </dl>
          <ul>
            <li v-if="$store.state.token" @click="$parent.goNav('/message')"><img src="/static/image/meunIcon.39f38dc98ad956615952d485d0e6af04.svg" />{{ $t('Message Center') }}<span class="side__subtitle__3QtYC"></span></li>
            <li @click="$parent.openKefu"><img src="/static/image/meunIcon2.5d0d78496889fb8b027f603254286fdf.svg" />{{ $t('Feedback') }}<span class="side__subtitle__3QtYC"></span></li>
            <li @click="doCopy($store.state.appInfo.h5_url)">
              <img src="/static/image/menuIcon5.5687ef4d1512d53aa3535e3b1088fe70.png" />{{ $t('Permanent Domain') }}<span class="side__subtitle__3QtYC">{{ $store.state.appInfo.h5_url }}</span>
            </li>
            <li @click="$parent.goNav('/abouts')"><img src="/static/image/meunIcon3.c51bbb9ebece978f1976397ab12acba7.svg" />{{ $t('About Us') }}<span class="side__subtitle__3QtYC"></span></li>
          </ul>
          <div class="nisd" v-if="!$store.state.token" @click="$parent.goNav('/login')">{{ $t('Login Now') }}</div>
          <div class="nisd" v-else @click="$parent.outLogin"><img src="/static/image/tuichu.93c1b9e3d4b4a7772481916ca32c074f.svg" />{{ $t('Safe Logout') }}</div>
        </div>
      </div>
    </van-popup>

    <div class="domainModal_domainView__FWCzg" v-if="$store.state.appInfo.index_modal == 1 && tanshow">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="changtanshow"></div>
      <div class="domainModal_content__1nBgc" style="width: 80%">
        <div id="domain" class="domainModal_contentTop__2C4jc">
          <img src="/static/image/hongbaocolse.png" @click="changtanshow" style="position: absolute; top: 5px; right: 13px; width: 0.6rem" alt="" />
          <div class="domainModal_middle__3gQPm" v-html="$store.state.appInfo.webcontent"></div>
        </div>
      </div>
    </div>
    
    <div class="login-modal-wrapper" v-if="showLogin">
      <div class="login-modal-overlay" @click="showLogin = false"></div>
      <div class="login-modal-content">
        <login @close="showLogin = false"></login>
      </div>
    </div>
    <div class="login-modal-wrapper" v-if="showRegister">
      <div class="login-modal-overlay" @click="showRegister = false"></div>
      <div class="login-modal-content">
        <login @close="showRegister = false" :initial-type="1"></login>
      </div>
    </div>

    <!-- 语言菜单底部弹窗 -->
    <van-popup v-model="showLangMenu" position="bottom" round>
      <div class="lang-menu-content">
        <div class="lang-title">{{ $t('Switch Language') }}</div>
        <div class="lang-item" :class="{ active: $i18n.locale === 'zh' }" @click="changeLang('zh')">简体中文</div>
        <div class="lang-item" :class="{ active: $i18n.locale === 'en' }" @click="changeLang('en')">English</div>
        <div class="lang-item" :class="{ active: $i18n.locale === 'pt' }" @click="changeLang('pt')">Português</div>
        <div class="lang-item" :class="{ active: $i18n.locale === 'th' }" @click="changeLang('th')">ไทย</div>
        <div class="lang-item" :class="{ active: $i18n.locale === 'vi' }" @click="changeLang('vi')">Tiếng Việt</div>
        <div class="lang-cancel" @click="showLangMenu = false">{{ $t('Cancel') }}</div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import login from '../login.vue';
import languageselector from '../ui/languageselector.vue';

export default {
  name: 'index',
  components: {
    login,
    languageselector,
  },
  data() {
    return {
      hongbashow: true,
      appShow: true,
      current: 0,
      bannerList: [],
      homenoticelis: [],
      leftshow: false,
      activeKey: 0,
      gameType: -1,
      tanshow: true,
      appshow: false,
      goInfo: null,
      showLogin: false,
      showRegister: false,
      isRefreshing: false,
      isDragging: false,
      startX: 0,
      startY: 0,
      initialLeft: 0,
      initialTop: 0,
      showSearchBox: false,
      searchKeyword: '',
      filteredGames: [],
      selectedPlatform: '',
      selectedFishingPlatform: '',
      filteredFishingGames: [],
      selectedJokerPlatform: '',
      filteredJokerGames: [],
      selectedLotteryPlatform: '',
      filteredLotteryGames: [],
      
      showLangMenu: false, // 控制语言选择弹窗的显示
    };
  },
  computed: {
    // 动态计算当前语言的简写文字
    currentLangText() {
      const lang = this.$i18n.locale || 'en';
      const map = { zh: '中文', en: 'EN', pt: 'PT', th: 'TH', vi: 'VN' };
      return map[lang] || lang.toUpperCase();
    }
  },
  created() {
    let that = this;
    that.getBanList();
    that.homenotice(); 
  },
  methods: {
    openBanner(url) {
      if (!url) return;
      if (/^https?:\/\//i.test(url)) {
        window.location.assign(url);
        return;
      }
      this.$parent.goNav(url);
    },
    async openLottery() {
      if (!this.$store.state.token) {
        this.showLogin = true;
        return;
      }
      try {
        const res = await this.$apiFun.get('/api/member/sso/lottery?destination=home', {});
        if (res.code !== 200 || !res.data || !res.data.url) throw new Error('开奖跳转地址为空');
        window.location.assign(res.data.url);
      } catch (error) {
        this.$parent.showTost(0, '开奖平台暂时无法打开，请稍后重试');
      }
    },
    // 切换语言方法
    changeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('language', lang); // 存入本地缓存
      localStorage.setItem('locale', lang);   // 双重保险
      this.showLangMenu = false;
    },
    openGogao(val) { this.goInfo = val; },
    changtanshow() { this.tanshow = !this.tanshow; },
    changGameType(type) {
      this.gameType = type;
      if (type === 4 && !this.selectedPlatform) {
        this.selectedPlatform = 'PG';
        this.filterGamesByPlatform();
      }
      if (type === 5) {
        this.selectedLotteryPlatform = '';
        this.filterLotteryGamesByPlatform();
      }
    },
    getGameImg(item, type) {
      let baseURL = sessionStorage.getItem('baseURL') || window.location.origin;
      let imgSrc = '';
      const imgFields = [
        'mobile_img', 'api_logo_img', 'check_yes_img', 'check_no_img', 'header_logo',
        'app_img', 'img', 'image', 'icon', 'cover', 'photo',
        'appimg', 'appimage', 'game_img', 'game_icon', 'game_image',
        'img_url', 'image_url', 'icon_url', 'icon_img',
        'appIcon', 'appImage', 'gameIcon', 'gameImage', 'gameImg',
        'iconUrl', 'imgUrl', 'imageUrl',
        'logo', 'thumb', 'thumbnail', 'pic', 'picture'
      ];
      for (const field of imgFields) {
        if (item[field] && item[field].trim() !== '') {
          imgSrc = item[field].trim();
          break;
        }
      }
      if (imgSrc) {
        let result = '';
        const uploadsHttpPattern = /\/uploads\/(https?:\/\/.*)/;
        const uploadsHttpMatch = imgSrc.match(uploadsHttpPattern);
        if (uploadsHttpMatch) { return uploadsHttpMatch[1]; }
        if (imgSrc.startsWith('http://') || imgSrc.startsWith('https://')) {
          result = imgSrc;
        } else if (imgSrc.startsWith('/uploads/')) {
          result = baseURL + imgSrc;
        } else if (imgSrc.startsWith('/')) {
          result = baseURL + imgSrc;
        } else {
          result = baseURL + '/' + imgSrc;
        }
        return result;
      }
      return '';
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      this.$parent.showTost(1, this.$t('Copy Successful')); 
    },
    changleftshow() { this.leftshow = !this.leftshow; },
    refreshBalance() {
      let that = this;
      if (that.isRefreshing) return;
      that.isRefreshing = true;
      that.$apiFun.post('/api/balance', {}).then(res => {
        if (res.code == 200 && res.data && res.data.balance !== undefined) {
          let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
          userInfo.balance = res.data.balance;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.$store.commit('changUserInfo');
        }
      }).catch(err => {}).finally(() => {
        that.isRefreshing = false;
      });
    },
    getBanList() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/bannerList', { type: 2 }).then(res => {
        if (res.code != 200) { that.showTost(0, res.message); }
        if (res.code == 200) { that.bannerList = Array.isArray(res.data) ? res.data : []; }
        that.$parent.hideLoading();
      }).catch(res => { that.$parent.hideLoading(); });
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        if (res.code != 200) { that.showTost(0, res.message); }
        if (res.code == 200) {
          that.homenoticelis = res.data;
          that.ok = true;
        }
      });
    },
    onChange(index) { this.current = index; },
    changhongbashow() { this.hongbashow = false; },
    changappShow() { this.appShow = false; },
    startDrag(event) {
      this.isDragging = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
      const tabBar = event.target.closest('.tab-bar');
      if (tabBar) {
        const rect = tabBar.getBoundingClientRect();
        this.initialLeft = rect.left;
        this.initialTop = rect.top;
      }
    },
    drag(event) {
      if (!this.isDragging) return;
      const deltaX = event.clientX - this.startX;
      const deltaY = event.clientY - this.startY;
      const tabBar = event.target.closest('.tab-bar');
      if (tabBar) {
        const parentRect = tabBar.parentElement.getBoundingClientRect();
        const tabRect = tabBar.getBoundingClientRect();
        let newLeft = this.initialLeft + deltaX;
        let newTop = this.initialTop + deltaY;
        newLeft = Math.max(0, Math.min(newLeft, parentRect.width - tabRect.width));
        newTop = Math.max(0, Math.min(newTop, parentRect.height - tabRect.height));
        tabBar.style.position = 'absolute';
        tabBar.style.left = newLeft - parentRect.left + 'px';
        tabBar.style.top = newTop - parentRect.top + 'px';
        tabBar.style.zIndex = '100';
      }
      event.preventDefault();
      event.stopPropagation();
    },
    stopDrag() { this.isDragging = false; },
    toggleSearchBox() {
      this.showSearchBox = !this.showSearchBox;
      if (this.showSearchBox) {
        this.searchKeyword = '';
        this.filteredGames = [];
      }
    },
    closeSearchBox() {
      this.showSearchBox = false;
      this.searchKeyword = '';
      this.filteredGames = [];
    },
    searchGames() {
      if (!this.searchKeyword.trim()) {
        this.filteredGames = [];
        return;
      }
      const keyword = this.searchKeyword.toLowerCase().trim();
      const games = this.$store.state.conciseList || [];
      this.filteredGames = games.filter(game => {
        const gameName = (game.name || '').toLowerCase();
        const platformName = (game.platform_name || '').toLowerCase();
        const gameCode = (game.game_code || '').toLowerCase();
        return gameName.includes(keyword) || platformName.includes(keyword) || gameCode.includes(keyword);
      });
    },
    selectPlatform(platform) {
      if (this.selectedPlatform === platform) {
        this.selectedPlatform = '';
        this.filteredGames = [];
      } else {
        this.selectedPlatform = platform;
        this.filterGamesByPlatform();
      }
    },
    filterGamesByPlatform() {
      if (!this.selectedPlatform) {
        this.filteredGames = [];
        return;
      }
      const platform = this.selectedPlatform.toLowerCase();
      const games = this.$store.state.conciseList || [];
      this.filteredGames = games.filter(game => {
        const platformName = (game.platform_name || '').toLowerCase();
        return platformName === platform;
      });
    },
    selectFishingPlatform(platform) {
      this.selectedFishingPlatform = platform;
      if (!platform) {
        this.filteredFishingGames = [];
      } else {
        this.filterFishingGamesByPlatform();
      }
    },
    filterFishingGamesByPlatform() {
      if (!this.selectedFishingPlatform) {
        this.filteredFishingGames = [];
        return;
      }
      const platform = this.selectedFishingPlatform.toLowerCase();
      const games = this.$store.state.gamingList || [];
      this.filteredFishingGames = games.filter(game => {
        const platformName = (game.platform_name || '').toLowerCase();
        return platformName === platform;
      });
    },
    selectJokerPlatform(platform) {
      this.selectedJokerPlatform = platform;
      if (!platform) {
        this.filteredJokerGames = [];
      } else {
        this.filterJokerGamesByPlatform();
      }
    },
    filterJokerGamesByPlatform() {
      if (!this.selectedJokerPlatform) {
        this.filteredJokerGames = [];
        return;
      }
      const platform = this.selectedJokerPlatform.toLowerCase();
      const games = this.$store.state.jokerList || [];
      this.filteredJokerGames = games.filter(game => {
        const platformName = (game.platform_name || '').toLowerCase();
        return platformName === platform;
      });
    },
    selectLotteryPlatform(platform) {
      this.selectedLotteryPlatform = platform;
      this.filterLotteryGamesByPlatform();
    },
    filterLotteryGamesByPlatform() {
      const category = this.selectedLotteryPlatform;
      let games = [];
      if (!category) {
        games = [
          ...(this.$store.state.lhcList || []),
          ...(this.$store.state.jscList || []),
          ...(this.$store.state.jwcList || []),
          ...(this.$store.state.qkcList || [])
        ];
      } else if (category === 'LHC') {
        games = this.$store.state.lhcList || [];
      } else if (category === 'JSC') {
        games = this.$store.state.jscList || [];
      } else if (category === 'JWC') {
        games = this.$store.state.jwcList || [];
      } else if (category === 'QKC') {
        games = this.$store.state.qkcList || [];
      } else {
        games = (this.$store.state.lotteryList || []).filter(game => {
          const platformName = (game.platform_name || '').toLowerCase();
          return platformName === category;
        });
      }
      this.filteredLotteryGames = games;
    },
  },
  mounted() {},
  updated() {},
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/2d87bbdbffeb4734e5c7.css';

.domainModal_content__1nBgc {
  overflow: auto;
  background-color: #1a1a1a; 
  color: #ffffff; 
}

/* ---------------- 顶部 logo & 语言切换区域 ---------------- */
.logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between; /* 左右两端对齐 */
  padding: 8px 15px 4px 15px;
  background-color: #000000;
}

.logo-icon {
  height: 28px; 
  width: auto;
  max-width: 120px;
  object-fit: contain;
}

/* 新增：多语言按钮样式 */
.lang-switch-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.globe-icon {
  color: #fff;
}
.lang-text {
  color: #fff;
  font-size: 13px;
  font-weight: bold;
}

/* 新增：语言菜单底部弹窗样式 */
.lang-menu-content {
  background-color: #1a1a1a;
  color: #fff;
  text-align: center;
}
.lang-title {
  padding: 15px;
  font-size: 14px;
  color: #999;
  border-bottom: 1px solid #333;
}
.lang-item {
  padding: 16px;
  font-size: 16px;
  border-bottom: 1px solid #333;
  transition: all 0.2s;
}
.lang-item:active {
  background-color: #333;
}
.lang-item.active {
  color: #1890ff; /* 选中的语言变蓝 */
  font-weight: bold;
}
.lang-cancel {
  padding: 16px;
  font-size: 16px;
  color: #999;
  margin-top: 6px;
  background-color: #222;
}
/* ---------------- 结束 ---------------- */

.banner-wrapper {
  padding: 0.1rem; 
  padding-top: 0.05rem; 
  background-color: transparent; 
  width: 100%;
  box-sizing: border-box;
}

.my-swipe {
  width: 100%;
  height: 3.8rem;
  border-radius: 8px; 
  overflow: hidden;
}

.banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover; 
}

.swiper-dots {
  display: flex;
  position: absolute;
  right: 15px; 
  bottom: 10px;
  width: 48px;
  height: 24px;
  background-color: rgba(0, 0, 0, 0.6); 
  border-radius: 12px;
  justify-content: center;
  align-items: center;
  
  .num {
    font-size: 12px;
    color: #fff;
    line-height: 24px;
    width: auto;
  }
  .sign {
    margin: 0 2px;
    font-size: 10px;
    color: rgba(255,255,255,0.7);
    line-height: 24px;
    position: static;
    transform: none;
  }
}

.leftbox {
  width: 7.5rem;
  height: 100%;
  background-color: #121212; 
  color: #cf866b;
  .side__main__1NhyG {
    box-sizing: border-box;
    padding: 0 20px;
    h3 {
      font-size: 20px;
      font-weight: 400;
      margin: 0;
      padding-top: 72px;
      color: #ffffff; 
    }
    .side__vip__1dW8w {
      background: url(/static/style/sidebr_vip_card.1ce7485811699286f87aae1827de7acf.png) no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 20px;
      color: #fff;
      position: relative;
      p {
        color: hsla(0, 0%, 100%, 0.6);
        font-size: 12px;
        margin: 5px 0 0 0;
      }
      .topxs {
        font-size: 16px;
      }
      dd {
        float: right;
        border: 0.02rem solid #fff;
        border-radius: 0.24rem;
        height: 0.48rem;
        line-height: 0.48rem;
        width: 1.88rem;
        text-align: center;
        font-size: 10px;
        position: absolute;
        top: 20px;
        right: 20px;
      }
    }
  }
  ul {
    list-style: none;
    margin-top: 0.36rem;
    li {
      display: block;
      line-height: 0.96rem;
      height: 0.96rem;
      border-bottom: 0.02rem solid #333333; 
      color: #e0e0e0; 
      font-size: 0.28rem;
      padding: 0 0.14rem;
      img {
        width: 0.36rem;
        vertical-align: middle;
        margin: -0.04rem 0.24rem 0 0;
      }
      span {
        float: right;
      }
    }
  }
  .nisd {
    position: absolute;
    width: 4.72rem;
    height: 0.8rem;
    line-height: 0.8rem;
    left: 0.9rem;
    bottom: 1rem;
    background: #333333; 
    border-radius: 0.4rem;
    border: 0;
    color: #ffffff; 
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      vertical-align: middle;
      margin: -0.04rem 0.08rem 0 -0.08rem;
      width: 0.32rem;
    }
  }
}

.gonggao {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.caosuo {
  color: #cf866b;
  width: 97%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .lefsg {
    flex: 1;
    .name {
      font-size: 12px;
    }
    .meys {
      display: flex;
      align-items: center;
      margin-top: 10px; 
      .lefs {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 700;
        color: #ffffff; 
        span {
          font-size: 18px;
          font-weight: 700;
        }
        .imsg {
          margin-left: 8px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            &.rotate {
              animation: rotate 1s linear infinite;
            }
          }
        }
        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      }
    }
  }
  
  /* 重写右侧四个图标容器的 CSS 布局 */
  .riggs {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start; /* 顶部对齐，防止文本折行后图标错位 */
    flex-wrap: nowrap;
    padding: 0;
    gap: 3px;
    flex: 1; /* 占据右侧全部剩余空间 */

    .lisImg {
      flex: 1; /* 平均分配宽度 */
      max-width: 65px; /* 控制最大宽度，避免挤占左侧登录区域 */
      text-align: center;
      color: #ffffff; 
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;

      .img-wrapper {
        position: relative;
        display: inline-block;
        width: 32px; /* 固定图标大小 */
        height: 32px;
        margin: 0 auto;
        
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          display: block;
        }
        
        .right-top-label {
          position: absolute;
          top: -2px;
          right: -12px;
          background: linear-gradient(90deg, #ff6b6b, #ee5a6f);
          color: #fff;
          font-size: 10px;
          border-radius: 4px;
          white-space: nowrap;
          z-index: 10;
          transform: scale(0.8); /* 缩小送3%标签，防止撑爆 */
        }
      }
      
      > img {
        width: 32px;
        height: 32px;
        object-fit: contain;
        display: block;
        margin: 0 auto;
      }
      
      .link-icon {
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      
      .icon-text {
        font-size: 11px; /* 缩小字号兼容英文 */
        line-height: 1.1;
        margin-top: 4px;
        width: 100%;
        text-align: center;
        word-wrap: break-word; /* 允许长单词换行 */
        white-space: normal; /* 允许折行 */
      }
    }
  }
}

.xiding {
  background-color: #000000; 
  position: fixed;
  left: 0;
  right: 0;
  z-index: 99;
  transition: top 0.3s ease;
}

.balance-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px; 
}


/* ----- 完美还原原来图片质感的多语言登录注册按钮 ----- */
.login-wrapper {
  display: flex;
  gap: 8px; /* 两个按钮的间距 */
  flex-shrink: 0;
  align-items: center;

  .button {
    height: 0.65rem;
    line-height: 0.65rem;
    padding: 0 12px;
    border-radius: 6px;
    font-size: 0.32rem !important;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    min-width: 1.4rem; /* 保证英文单词不被挤扁 */
    white-space: nowrap; 
    text-align: center;
    transition: all 0.2s;
  }

  /* 还原原来的 "注册" 白色按钮外观 */
  .custom-reg-btn {
    background-color: #ffffff;
    color: #555555;
    border: 1px solid #dcdcdc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05); /* 微微的立体阴影 */
  }
  .custom-reg-btn:active {
    background-color: #f5f5f5;
  }

  /* 还原原来的 "登录" 蓝色渐变按钮外观 */
  .custom-login-btn {
    background: linear-gradient(180deg, #60a5fa 0%, #1890ff 100%); /* 仿制原图的蓝底渐变 */
    color: #ffffff;
    border: none;
    box-shadow: 0 2px 4px rgba(24, 144, 255, 0.3); /* 蓝色立体发光阴影 */
  }
  .custom-login-btn:active {
    background: linear-gradient(180deg, #3b82f6 0%, #096dd9 100%);
  }
}

.gameBoxs {
  background-color: #000000; 
  box-sizing: border-box;
  color: #e0e0e0; 
  height: 100%;
  min-height: 608px;
  display: flex;
  justify-content: space-between;

  /* 3. 仅针对左侧菜单的文字溢出做最小化修复 */
  .lfst {
    width: 1.25rem; /* 恢复原本的宽度，不挤压右侧 */
    border-radius: 20px;
    border-top: none;
    position: fixed;
    left: 0.05rem; /* 稍微往左靠一点点 (原来是 0.1rem) */
    bottom: 75px; 
    overflow-y: auto; 
    z-index: 99;
    transition: top 0.3s ease;
    transform: translateZ(0);
    -webkit-transform: translateZ(0);
    will-change: top;
    -webkit-will-change: top;
    
    &::-webkit-scrollbar {
      display: none;
    }
    
    .ls.active {
      color: #1989fa; 
      background-image: url(/static/style/gameicon_1773179136_g100pWLyRS.png);
      span { color: #1989fa; }
    }
    
    .ls {
      text-align: center;
      border-radius: 10px;
      padding: 6px 2px;
      background-image: url(/static/style/bbbb.png);
      background-size: 100% 100% !important; /* 关键：强制背景拉伸包住文字 */
      background-repeat: no-repeat !important;
      background-position: center !important;
      transition: none !important;
      animation: none !important;
      width: 100% !important;
      box-shadow: none !important;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 65px; /* 防止背景被压扁 */
      margin-bottom: 4px;
      
      img {
        width: 30px; /* 图标稍小一点 */
        display: block;
        margin: 0 auto 3px;
      }
      span {
        font-size: 11px; /* 缩小字号 */
        display: block;
        color: #666666; 
        font-weight: 500;
        line-height: 1.1;
        white-space: normal; /* 关键：允许换行 */
        word-wrap: break-word; /* 关键：长单词换行 */
        width: 100%;
      }
    }
  }

  /* 1. 恢复右侧内容区域的间距，解决遮挡问题 */
  .content-area {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    margin-left: 1.3rem; /* 恢复原来的 1.3rem */
  }

  .cross-lottery-panel {
    box-sizing: border-box;
    width: 100%;
    padding: 10px 7px 78px;
  }

  .cross-lottery-card {
    overflow: hidden;
    width: 100%;
    border: 1px solid #d7e0eb;
    border-radius: 10px;
    background: #ffffff;
    color: #203047;
    box-shadow: 0 4px 14px rgba(33, 69, 113, 0.12);
    cursor: pointer;
  }

  .cross-lottery-card__head {
    min-height: 62px;
    padding: 0 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    border-bottom: 1px solid #e6ebf1;

    > div { min-width: 0; display: flex; flex-direction: column; gap: 6px; }
    strong { font-size: 16px; font-weight: 800; }
    span { color: #7d8999; font-size: 11px; }
    em { flex: none; display: flex; align-items: center; gap: 4px; color: #287452; font-size: 11px; font-style: normal; font-weight: 700; }
    em i { width: 5px; height: 5px; border-radius: 50%; background: #26b778; }
  }

  .cross-lottery-card__body {
    min-height: 126px;
    padding: 18px 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  .cross-lottery-card__copy {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
    strong { font-size: 14px; font-weight: 800; }
    span { color: #758297; font-size: 11px; line-height: 1.7; }
  }

  .cross-lottery-card__art {
    position: relative;
    width: 86px;
    height: 72px;
    flex: 0 0 86px;
    img { position: absolute; z-index: 2; left: 0; top: 8px; width: 50px; height: 50px; object-fit: contain; transform: rotate(-8deg); }
    i { position: absolute; width: 18px; height: 18px; border: 3px solid #fff; border-radius: 50%; box-shadow: 0 2px 5px rgba(18, 57, 108, 0.18); }
    i:nth-of-type(1) { right: 2px; top: 2px; background: #ef5559; }
    i:nth-of-type(2) { right: 0; bottom: 2px; background: #2b80da; }
    i:nth-of-type(3) { left: 20px; bottom: 0; background: #2ab474; }
  }

  .cross-lottery-card__foot {
    min-height: 52px;
    padding: 0 10px 0 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    border-top: 1px solid #e6ebf1;
    background: #f8fafc;

    > span { min-width: 0; overflow: hidden; color: #7f8b9b; font-size: 11px; text-overflow: ellipsis; white-space: nowrap; }
    button { height: 30px; margin: 0; padding: 0 12px; display: flex; align-items: center; gap: 4px; border: 0; border-radius: 15px; background: #1769de; color: #fff; font-size: 12px; font-weight: 700; }
    button b { font-size: 17px; line-height: 1; }
  }

  .rigts {
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: .1rem;
    align-content: start;
    position: relative;
    padding: 0px 5px 70px;
    
    .game-item {
      position: relative;
      margin-top: 10px;
      text-align: center;
      cursor: pointer;
      
      .game-icon-container {
        position: relative;
        display: inline-block;
        img {
          width: 48%;
          border-radius: 20px;
          display: block;
          margin: 0 auto;
        }
        .api-icon {
          position: absolute;
          top: 0;
          right: 2%;
          width: 36px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
          img {
            width: 30px;
            object-fit: contain;
            border-radius: 0 15px 0 0;
          }
        }
      }
      .game-name {
        position: absolute;
        bottom: 5px;
        left: 0;
        right: 0;
        text-align: center;
        font-size: 14px;
        color: #ffffff;
        padding: 2px 0;
        border-radius: 0 0 20px 20px;
        width: 48%;
        margin: 0 auto;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    
    &.hot-grid {
      .game-item {
        margin-top: 1px;
        .game-icon-container img {
          width: 98% !important;
          object-fit: cover !important;
          flex-shrink: 0 !important;
          box-sizing: border-box !important;
        }
        .game-name { width: 98% !important; }
      }
    }
    
    &.single-column {
      grid-template-columns: 1fr;
      .game-item {
        .game-icon-container img { width: 98% !important; margin-top: 10px; }
        .game-name { width: 98% !important; }
      }
    }
    
    &.three-column {
      position: relative;
      grid-template-columns: repeat(3, 1fr);
      padding: 40px 5px 70px;
      .game-item {
        margin-top: 0;
        .game-icon-container img {
          width: 98%!important;
          object-fit: cover!important;
          flex-shrink: 0!important;
          box-sizing: border-box!important;
        }
        .game-name {
          width: 100% !important;
          bottom: 0;
          border-radius: 0 0 8px 8px;
        }
      }
    }
    
    .game-item.full-width {
      .game-icon-container img { width: 98% !important; }
      .game-name { width: 98% !important; }
    }
  }
}

/* 2. 恢复顶部 Tab 栏的间距 */
.top-tab-bar {
  width: calc(100% - 1.3rem); /* 恢复原来的 1.3rem */
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #000000; 
  padding: 5px;
  margin: 5px 0 0 1.3rem; /* 恢复原来的 1.3rem */
  z-index: 999;
  
  .game-type-tabs {
    display: flex;
    gap: 5px;
    overflow-x: auto;
    flex: 1;
    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
    
    .game-type-tab {
      padding: 5px 20px;
      border-radius: 4px;
      font-size: 14px;
      cursor: pointer;
      white-space: nowrap;
      background-image: url(/static/style/ddh.png);
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      color: #333333; 
      border: none;
      outline: none;
      transition: all 0.2s ease;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      &.active {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIcAAAA5CAMAAAAr+cg9AAAAYFBMVEUAAABjt/1ks/xltvpmtv9muf1mt/4LZ+ZhtPw7kfBmt/xitPsDX+FHnPQPaeQNaOQQaeQdd+jR5P/Z6f/G3f/p8v/w9v/g7P/L4P/k7/8CXeFbl+z1+f9xpfAzfeeRuvXavtWnAAAAEnRSTlMAMxBGHltqJBaXJk/lfavGfWGnzvn6AAAEK0lEQVRYw82Yi3qiMBCFF1DLCoKLyGUo+P5vuTMc4gGqlN0udU/CTGYysf+XxNb647/X2xb6Q4RzEss2SpPzSpjwnIqq65p/r64TVfzrbQVFrAy3/L1430b5zViST0iMoq2LonhXkAJ9cEigPcswixHbYPogazvdk6XNSJWiLFbpvfiCsnZpS95i6bLie5Tplrw9xWjvdVc65uj1sTbXx1la6tqbRmLvGcYVKvBoZ4K5wRcFvA1Y1of9DKxDmkRY1XJH5hhfEFFW6xGInxLj29RI6s/fsNJdr7U2qJ42yzDdi2mXqh8vdY7LuKqT8wTE11PJa+g6OPN9NdwgBpyGn9c4ixdgOUDgqtnJ+Im09QOVHC7OjYMVS1jdSuKPMDyRsqy1meXIOlQjYqYPucAMJzkBw1ekQb+IeP54O27lc9ULc18tb0c3xA9jycrygq7NLHSBYcwhZXk6PIwuzs9KYTK9Ib7j+CXN5aF09TqVf13SyC/HEeqxWOHHZtmV7fOCx9mbJCFA/F0sVc+WXb5flcQ7cIQ76TRBigwdCXo0N+8S7FNZigVcx7WDRI4hOCLp7qVcy0VMPIBknmtZMEVgHXrfOglCvz8WvabZi6QgelF3jqNFDkb79OHkPFjIcWHf6c2Na1s5DxzngaMaDB84Ts6DpVxFzxdGZvDkCO16HHuOCs3VM5wNGKxvS2uM4wgOux+cAa05Ng77KXXjKib6IHsKW83T1vV+DByRNNXr1N05ApGqyvNKDTsfncldGgGMy7PDYciEG1o0BOOwE2/g8GLJXyeJ7xyJ3PJX6SYpOPydd5Imf5UaOXtHHxyRvO5gRAJvB45jkEibv0atpI5DL8hJpOrFNwuHuOSco2EpY2eZYOH4zYiWiRyCIz6AKEeUSvvhV18Fixh5s24OI0RulXvQxm682tww0O2I+muKCxIcRPLFPyPV00mKvE9mPii37cCx4GCiRLqMnxz45xKheuY4AT+esCq3hAV9hiEXdpLYdiiHKdQN2cfSLn3IzS6rxLI1aiXeBzgWHIxuyAkg5XOU6Xi5qFyJcYqCox0LNyQ6ibTlsi4cfr2ybkVO3A53Q4K9geD/x2mbDNXOMoycMY0XjqpHiTvG+B9c25C9Hk2Xj79A4JcN484MEsi4HMeIaLWzpOr0UPYR3ixU6EDkdv0G6dVwGJPtsJMxkEMi0t2yQjV8q4WhizHgnD00Vw5Zy+Td2ZFIcjAMnAp1BzmlWtMoylbKbo2IpKcnGA7ESGJRdc0W6sSUKMUDDO4ISA4/FWUrxenPAyhwN0jCHdnZlhiJ6vRzC50Opn1km2EYjwQQL8CebCTsReAtYYxIFGUjRUsUZDESQ1mpiH6lPIUwimUMkCjK0dtGR4UgxacoyvKvdYQLCfEZiT1QaB0NAfpCo6NBc8JPWIvy3foNJmnskhJAWk4AAAAASUVORK5CYII=);
        color: #ffffff; 
        font-weight: bold;
      }
    }
  }
  
  .search-icon {
    display: flex;
    align-items: center;
    .search-img {
      width: 20px;
      height: 20px;
      cursor: pointer;
      background: #1a1a1a;
      border: 0.04415rem solid #444;
      border-right: none;
      transition-duration: .15s;
      padding-left: 0.14493rem;
      padding-right: 0.28986rem;
      border-radius: 15px 0 0 15px;
      transform: translateY(-1px);
    }
  }
  
  .search-box {
    position: absolute;
    left: 1.3rem;
    right: 0;
    padding: 3px;
    display: flex;
    background: #1a1a1a; 
    border-radius: 15px 0 0 15px;
    
    .search-input-wrapper {
      flex: 1;
      display: flex;
      align-items: center;
      .search-img-inside {
        position: absolute;
        left: 10px;
        width: 16px;
        height: 16px;
        z-index: 1;
      }
      .search-input-with-icon {
        flex: 1;
        padding: 4px 4px 4px 32px;
        border-radius: 20px;
        font-size: 14px;
        background: #333333; 
        color: #ffffff; 
        border: 0.02415rem solid #555555;
        border-right: none;
        &::placeholder { color: #999999; }
      }
    }
    
    .search-close {
      margin-left: -30px;
      cursor: pointer;
      font-size: 24px;
      color: #999;
    }
  }
}

/* 强制隐藏编译后因路径丢失而变成“口”的字体图标 */
.riggs .lisImg .icon-text::before,
.riggs .lisImg .icon-text::after,
.riggs .lisImg::before,
.riggs .lisImg::after {
  display: none !important;
  content: none !important;
}

.realbet-content,
.sport-content {
  box-sizing: border-box !important;
  display: grid !important;
  gap: 0.1rem !important;
  align-content: start !important;
  position: relative !important;
  padding: 0 5px 70px !important;
  grid-template-columns: 1fr !important;
}

.realbet-icon-container,
.sport-icon-container {
  width: 100% !important;
  height: 120px !important;
  min-width: 100% !important;
  max-width: 100% !important;
  min-height: 120px !important;
  max-height: 120px !important;
  overflow: hidden !important;
  border-radius: 8px !important;
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-sizing: border-box !important;
  flex-shrink: 0 !important;

  img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    border-radius: 22px !important;
    display: block !important;
    padding: 8px !important;
    box-sizing: border-box !important;
  }
}

.login-modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .login-modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }
  
  .login-modal-content {
    position: relative;
    z-index: 1001;
    width: 90%;
    max-width: 400px;
    background: #1a1a1a; 
    border-radius: 12px;
    overflow: hidden;
  }
}

.app-download-bar-v2 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #1a1a1a; 
  
  .flex-center {
    display: flex;
    align-items: center;
    flex: 1;
    width: 80%;
    height: 1rem;
  }
  
  .close-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.0rem;
    height: 0.5rem;
    font-size: 0.76rem;
    color: #ffffff; 
    cursor: pointer;
    margin-right: 0.1rem;
  }
  
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    .fit-image {
      width: 0.8rem;
      height: 0.7rem;
      object-fit: contain;
    }
  }
  
  .medium-text { font-size: 0.38rem; }
  .text { margin-left: 0.2rem; color: #ffffff; }
  
  .download-btn {
    padding: 0.1rem 0.6rem;
    color: #3d72fa;
    font-size: 0.35rem;
    border-radius: 0.1rem;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/index.vue